// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__6BxpL","topWrap":"styles_topWrap__72x_D","title":"styles_title__XORoY","counter":"styles_counter__gRLg2"};
module.exports.__checksum = "6bd5d7d1dd1e"